/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, {
    useContext, useEffect, useRef, useState
} from 'react';
import { ExpansionPanelGroup } from '@ferris/react/components/expansion-panel';
import { TrackingContext } from '@vrbo/react-event-tracking';
import throttle from 'lodash.throttle';
import './EgFAQs.less';
import { Tabs, TabItem } from '@ferris/react/components/tabs';
import { shallowEqual, useSelector } from 'react-redux';
import TranslationUtil from '../../utils/TranslationUtil';
import { createImpressionEvent, createInteractionEvent } from '../../utils/EventProviders/EgClickstreamUtil';
import CustomExpansionPanel from '../FAQs/CustomExpansionPanel';
import { tabUseEffect } from '../FAQs';

const EgFAQs = () => {
    const getPropsFromState = (state) => {
        const { app } = state;
        const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
        const getTranslation = suffix => translations.getTranslation(`EG.FAQs.${suffix}`, {
            siteName: app.displayBrand,
            brand: app.displayBrand,
            brandName: app.displayBrand
        });
        const faqs = [
            {
                title: getTranslation('subtitle1'),
                qaPairs: [
                    { question: getTranslation('question1'), answer: getTranslation('answer1') },
                    { question: getTranslation('question2'), answer: getTranslation('answer2') },
                    { question: getTranslation('question3'), answer: getTranslation('answer3') },
                    { question: getTranslation('question4'), answer: getTranslation('answer4') }
                ]
            },
            {
                title: getTranslation('subtitle2'),
                qaPairs: [
                    { question: getTranslation('question5'), answer: getTranslation('answer5') },
                    { question: getTranslation('question6'), answer: getTranslation('answer6') },
                    { question: getTranslation('question7'), answer: getTranslation('answer7') }
                ]
            },
            {
                title: getTranslation('subtitle3'),
                qaPairs: [
                    { question: getTranslation('question8'), answer: getTranslation('answer8') },
                    { question: getTranslation('question9'), answer: getTranslation('answer9') },
                    { question: getTranslation('question10'), answer: getTranslation('answer10') }
                ]
            }
        ];
        return {
            faqs
        };
    };

    const { faqs } = useSelector(getPropsFromState, shallowEqual);

    const { trigger } = useContext(TrackingContext);

    const faqSectionRef = useRef();

    const isFaqSectionVisible = () => {
        /* istanbul ignore else */
        if (faqSectionRef.current) { // protect against SSR.
            // eslint-disable-next-line max-len
            return (faqSectionRef.current.getBoundingClientRect().top - (faqSectionRef.current.offsetHeight + 150)) < 0;
        }
        return false;
    };

    const [faqSeen, setFaqSeen] = useState(false);

    useEffect(() => {
        if (faqSeen) {
            trigger('impression', createImpressionEvent('faq_section.viewed', 'Property Onboarding', '', '2.3.0'));
        }
    }, [faqSeen]);

    const onScroll = () => {
        if (isFaqSectionVisible()) {
            setFaqSeen(true);
        }
    };
    const scrollHandler = throttle(onScroll, 333);
    const tabSection = useRef();
    const tabsRef = useRef([]);

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);
        trigger('impression', createImpressionEvent('faq_section.presented', 'Property Onboarding', '', '2.3.0'));
        return () => {
            window.removeEventListener('scroll', scrollHandler);
        };
    }, []);

    useEffect(tabUseEffect(tabSection, tabsRef), []);
    const clickTrigger = identifier => (opened) => {
        trigger('interaction', createInteractionEvent('faq_section.selected', 'Property Onboarding', `${identifier}.${opened ? 'open' : 'close'}`, undefined, '2.3.0'));
    };

    return (
        <div id="eg-faqs" className="eg-faqs" itemScope itemType="https://schema.org/FAQPage" ref={faqSectionRef}>
            <h1 className="title">FAQs</h1>
            <Tabs onTabItemClick={function noRefCheck() { }} scrollable={false} classes="tabs" ref={tabSection}>
                {faqs.map((subTitle, tabIndex) => (
                    <TabItem classes="tab-item" contentId={`tab-content-${tabIndex + 1}`} selected={tabIndex === 0} tabTitle={(<p className="tab-title">{subTitle.title}</p>)}>
                        <ExpansionPanelGroup offset classes="expansion-panel-group" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                            {subTitle.qaPairs.map((qaPair, i) => (
                                <CustomExpansionPanel
                                    question={qaPair.question}
                                    answer={qaPair.answer}
                                    onToggle={clickTrigger(`${subTitle.title}.${i}`)}
                                />
                            ))}
                        </ExpansionPanelGroup>
                    </TabItem>
                ))}
            </Tabs>
        </div>
    );
};

EgFAQs.displayName = 'EgFAQs';
export default EgFAQs;
